export default __webpack_public_path__ + "static/media/49e04211046a25c8719ddbdd2e2d2d531577802667163.1fbefda2.webp";